<template>
  <div class="shop-size-template-selector">
    <div v-for="shop in shopList" :key="shop.id">
      <div class="shop-template-item">
        <div class="shop-info">
          <img :src="shop.icon" class="shop-icon" />
          <span class="shop-name">{{ shop.shortTitle || shop.title }}</span>
        </div>
        <div class="template-selector">
          <el-select
            v-model="valuesMap[shop.id]"
            value-key="templateId"
            name-key="templateName"
            placeholder="请选择尺码模板"
            @change="val => handleTemplateChange(val, shop.id)"
            filterable
            clearable
            @focus="() => selectFocus(shop.id)"
          >
            <el-option v-for="item in templateOptions[shop.id]" :key="item.templateId" :label="item.templateName" :value="item.templateId">
              <el-tag size="mini">{{ sizeTagListMap[item.templateSubType] }}</el-tag>
              <span style="float: right">{{ item.templateName }}</span>
            </el-option>
          </el-select>
          <el-button type="text" @click="handleEditSizeConf(shop.id)" :disabled="!valuesMap[shop.id]">预览/编辑</el-button>
        </div>
      </div>
      <div v-if="errorsMap[shop.id]" class="shop-error el-form-item__error">{{ errorsMap[shop.id] }}</div>
    </div>
  </div>
</template>
<script>
import { queryFxgSizeTemplateList } from '@/servers/prod/center/fxg.js';
import { cloneDeep } from 'lodash';
export default {
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        value: {
        type: Array,
            default() {
                return [];
            },
        },
        shopList: {
            type: Array,
            default() {
                return [];
            },
        },
        showEditBtn: {
            type: Boolean,
            default() {
                return true
            }
        },
        specifications: {
            type: Array,
            default() {
                return [];
            },
        },
        componentTemplateRule: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data(){
        return {
            valuesMap: {},
            errorsMap: {},
            shopBrandList:[],
            templateOptions:{},
            specialSizeList: [],
            loading: {},
            isInternalUpdate: false, // 标记是否为内部更新，避免死循环
            sizeTagListMap:{
                children_clothing:'童装',
                shoes:'鞋靴类',
                undies:'内衣',
                clothing:'服装',
            },
        }
    },
    watch:{
        valuesMap: {
            deep: true,
            handler(v) {
                let values = Object.values(v).map(item => {
                    return item
                }).filter(item=>item.templateId)
                this.$emit('change', values);
                // 实时校验（避免内部初始化触发死循环）
                if(!this.isInternalUpdate){
                    this.validateForm();
                }
            },
        },
        shopList:{
            deep: true,
            immediate: true,
            handler(v) {
                if(v){
                    this.initValuesMap()
                }
            },
        },
        specifications: {
            handler() {
                this.specialSizeList = [];
                if (this.specifications?.length) {
                    this.specifications.forEach(item => {
                        if (item.name.includes('尺码') || item.name.includes('鞋码')) {
                            item.values.forEach(i => {
                                i.value && i.value !== '无规格' && this.specialSizeList.push(i.value.trim());
                            });
                        }
                    });
                    // 尺码规格变化后，重新校验
                    this.validateForm();
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        selectFocus(shopId) {
            if (!this.templateOptions[shopId]) {
                this.getSizeTempListBy('', shopId);
            }
        },
        async getSizeTempListBy(query, shopId) {
            this.$set(this.loading, shopId, true);
            const supportTemplateSubType = this.componentTemplateRule?.supportTemplateSubType;
            try {
                const curShop = this.shopList.find(shop => shop.id == shopId)
                const res = await queryFxgSizeTemplateList({ shopId }, { source: curShop?.source });
                const records = res.records || [];
                const data = records.filter(it => !supportTemplateSubType || it.templateSubType === supportTemplateSubType).map(it => ({ ...it, shopId }))
                this.$set(this.templateOptions, shopId, data);
                this.loading[shopId] = false;
            } catch (error) {
                this.loading[shopId] = false;
            }
        },
        // 初始化valuesMap
        initValuesMap() {
            // 设置内部更新标志，避免触发value的watch
            this.isInternalUpdate = true;
            
            this.shopList.forEach(shop => {
                const findItem = this.value.find(v => v.shopId == shop.id) || {};
                const currentItem = this.valuesMap[shop.id] || {};
                
                // 只有当数据真正发生变化时才更新
                if (JSON.stringify(findItem) !== JSON.stringify(currentItem)) {
                    this.$set(this.valuesMap, shop.id, findItem);
                }
            });
            this.isInternalUpdate = false;
        },
        // 处理模板变更（接收 templateId）
        handleTemplateChange(templateId, shopId) {
            if(templateId){
                const template = this.templateOptions[shopId]?.find(t => t.templateId === templateId)
                this.$set(this.valuesMap, shopId, template || {});
            } else {
                this.$set(this.valuesMap, shopId,'');
            }
            this.revalidateShop(shopId);
        },
        handleEditSizeConf(shopId) {
            const templateInfo = this.valuesMap[shopId]
            this.$emit('editShopSize', {
                shopId,
                templateInfo,
                editSuccessFn: this.editSuccessFn
            })
        },
        editSuccessFn(item){
            if(!item.shopId) return
            this.$set(this.valuesMap, item.shopId, item || {});
            const findIndex = this.templateOptions[item.shopId]?.findIndex(t => t.templateId === item.templateId)
            findIndex > -1 && this.$set(this.templateOptions[item.shopId], findIndex, item)
            this.revalidateShop(item.shopId);
        },
        // 批量重新校验
        validateForm(){
            const must = !!this.componentTemplateRule?.mustInput
            if(must) {
                (this.shopList || []).forEach(s => this.revalidateShop(s.id))
            } else {
                this.errorsMap = {}
            }
            return !Object.values(this.errorsMap).some(v => !!v)
        },
        // 单店铺校验并写入错误文案
        revalidateShop(shopId){
            const must = !!this.componentTemplateRule?.mustInput
            if(!must) return
            const err = this.validateItem(shopId)
            this.$set(this.errorsMap, shopId, err || '')
        },
        validateItem(shopId) {
            const item = this.valuesMap[shopId] || {}
            if (!item.templateId) return null

            const { supportTemplateSubType } = this.componentTemplateRule || {}
            if (supportTemplateSubType && item.templateSubType !== supportTemplateSubType) {
                return `请选择 ${this.sizeTagListMap[supportTemplateSubType]} 类型的尺码模板`
            }

            const componentData = JSON.parse(item.componentData || '{}')
            const sizeValues = (componentData.selected_size || []).map(s => s.trim())
            const selectedSpecs = componentData.selected_specs || []

            const usefulDimensions = this.componentTemplateRule?.sizeDimensions?.usefulDimensions || []
            const missingSpec = usefulDimensions.find(spec => !selectedSpecs.includes(spec))
            if (missingSpec) {
                return '尺码表未完善，请补充'
            }

            const lackSizeList = this.specialSizeList.filter(size => !sizeValues.includes(size))
            if (lackSizeList.length) {
                return `尺码模板中缺少尺码 ${lackSizeList.join('、')} 信息，请补充！`
            }

            const hasJunma = sizeValues.some(size => ['均码', 'F', 'XF', 'XXF'].includes(size))
            if (sizeValues.length > 1 && hasJunma) {
                return '尺码表填写有误，您的尺码中包含均码，不能同时设置其他尺码'
            }

            return null
        },
    },
}
</script>
<style lang="scss" scoped>
    
.shop-size-template-selector {
  .shop-template-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    
    .shop-info {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin-right: 8px;
      min-width: 200px;
      align-self: flex-start;
      
      .shop-icon {
        height: 16px;
        margin-right: 5px;
      }
    }
    
    .template-selector {
      width: 100%;
      display: flex;
      align-items: center;
      
      .el-select {
        margin-right: 16px;
        width: 240px;
      }
    }
   
  }
    .shop-error {
        position: unset;
        margin-top: -10px;
        margin-left: 216px;
    }
}
.el-select-dropdown .el-select-dropdown__item{
     margin-bottom: 4px!important;
}
</style>
